const PdfFiles =

  [


    {
      "id": "slbphy1",
      "name": "syllabus-physics",
      "type": "syllabus",
      "subject": "physics",
      "topic": "SP",
      "pdfPath": "slbphy27.pdf"
    },
    {
      "id": "slbche1",
      "name": "syllabus-chemistry",
      "type": "syllabus",
      "subject": "chemistry",
      "topic": "SC",
      "pdfPath": "slbche27.pdf"
    },
    {
      "id": "slbmath1",
      "name": "syllabus-mathematics",
      "type": "syllabus",
      "subject": "mathematics",
      "topic": "SM",
      "pdfPath": "slbmath27.pdf"
    },


    {
      "id": "26pyq1math",
      "name": "2026 Mathematics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "26pyq1math.pdf"
    },
    {
      "id": "25pyq1math",
      "name": "2025 Mathematics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "25pyq1math.pdf"
    },
    {
      "id": "25pyq2math",
      "name": "2025 Mathematics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "25pyq2math.pdf"
    },
    {
      "id": "24pyq1math",
      "name": "2024 Mathematics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "24pyq1math.pdf"
    },
    {
      "id": "24pyq2math",
      "name": "2024 Mathematics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "24pyq2math.pdf"
    },
    {
      "id": "23pyq1math",
      "name": "2023 Mathematics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "23pyq1math.pdf"
    },
    {
      "id": "23pyq2math",
      "name": "2023 Mathematics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "23pyq2math.pdf"
    },
    {
      "id": "22pyq1math",
      "name": "2022 Mathematics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "22pyq1math.pdf"
    },
    {
      "id": "22pyq2math",
      "name": "2022 Mathematics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "math",
      "pdfPath": "22pyq2math.pdf"
    },


    {
      "id": "26pyq1phy",
      "name": "2026 Physics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "26pyq1phy.pdf"
    },
    {
      "id": "25pyq1phy",
      "name": "2025 Physics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "25pyq1phy.pdf"
    },
    {
      "id": "25pyq2phy",
      "name": "2025 Physics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "25pyq2phy.pdf"
    },
    {
      "id": "24pyq1phy",
      "name": "2024 Physics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "24pyq1phy.pdf"
    },
    {
      "id": "24pyq2phy",
      "name": "2024 Physics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "24pyq2phy.pdf"
    },
    {
      "id": "23pyq1phy",
      "name": "2023 Physics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "23pyq1phy.pdf"
    },
    {
      "id": "23pyq2phy",
      "name": "2023 Physics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "23pyq2phy.pdf"
    },
    {
      "id": "22pyq1phy",
      "name": "2022 Physics shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "22pyq1phy.pdf"
    },
    {
      "id": "22pyq2phy",
      "name": "2022 Physics shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "physics",
      "pdfPath": "22pyq2phy.pdf"
    },


    {
      "id": "26pyq1che",
      "name": "2026 Chemistry shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "26pyq1che.pdf"
    },
    {
      "id": "25pyq1che",
      "name": "2025 Chemistry shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "25pyq1che.pdf"
    },
    {
      "id": "25pyq2che",
      "name": "2025 Chemistry shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "25pyq2che.pdf"
    },
    {
      "id": "24pyq1che",
      "name": "2024 Chemistry shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "24pyq1che.pdf"
    },
    {
      "id": "24pyq2che",
      "name": "2024 Chemistry shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "24pyq2che.pdf"
    },
    {
      "id": "23pyq1che",
      "name": "2023 Chemistry shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "23pyq1che.pdf"
    },
    {
      "id": "23pyq2che",
      "name": "2023 Chemistry shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "23pyq2che.pdf"
    },
    {
      "id": "22pyq1che",
      "name": "2022 Chemistry shift 1 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "22pyq1che.pdf"
    },
    {
      "id": "22pyq2che",
      "name": "2022 Chemistry shift2 PYQs",
      "type": "chapterwisepyq",
      "subject": "chemistry",
      "pdfPath": "22pyq2che.pdf"
    },




    {
      "id": "ncertbookphy1",
      "name": "1-UNITS AND MEASUREMENT",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "ncertbookphy1.pdf"
    },
    {
      "id": "ncertbookphy2",
      "name": "2-MOTION IN A STRAIGHT LINE",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "ncertbookphy2.pdf"
    },
    {
      "id": "ncertbookphy3",
      "name": "3-MOTION IN A PLANE",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "ncertbookphy3.pdf"
    },
    {
      "id": "ncertbookphy4",
      "name": "4-LAWS OF MOTION",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "ncertbookphy4.pdf"
    },
    {
      "id": "ncertbookphy5",
      "name": "5-WORK, ENERGY AND POWER",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "ncertbookphy5.pdf"
    },
    {
      "id": "ncertbookphy6",
      "name": "6-SYSTEMS OF PARTICLES AND ROTATIONAL MOTION",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP06",
      "pdfPath": "ncertbookphy6.pdf"
    },
    {
      "id": "ncertbookphy7",
      "name": "7-GRAVITATION",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP07",
      "pdfPath": "ncertbookphy7.pdf"
    },
    {
      "id": "ncertbookphy8",
      "name": "8-MECHANICAL PROPERTIES OF SOLIDS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP08",
      "pdfPath": "ncertbookphy8.pdf"
    },
    {
      "id": "ncertbookphy9",
      "name": "9-MECHANICAL PROPERTIES OF FLUIDS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP09",
      "pdfPath": "ncertbookphy9.pdf"
    },
    {
      "id": "ncertbookphy10",
      "name": "10-THERMAL PROPERTIES OF MATTER",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP10",
      "pdfPath": "ncertbookphy10.pdf"
    },
    {
      "id": "ncertbookphy11",
      "name": "11-THERMODYNAMICS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP11",
      "pdfPath": "ncertbookphy11.pdf"
    },
    {
      "id": "ncertbookphy12",
      "name": "12-KINETIC THEORY",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP12",
      "pdfPath": "ncertbookphy12.pdf"
    },
    {
      "id": "ncertbookphy13",
      "name": "13-OSCILLATIONS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP13",
      "pdfPath": "ncertbookphy13.pdf"
    },
    {
      "id": "ncertbookphy14",
      "name": "14-WAVES",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP14",
      "pdfPath": "ncertbookphy14.pdf"
    },
    {
      "id": "ncertbookphy15",
      "name": "1-ELECTRIC CHARGES AND FIELDS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP15",
      "pdfPath": "ncertbookphy15.pdf"
    },
    {
      "id": "ncertbookphy16",
      "name": "2-ELECTROSTATIC POTENTIAL AND CAPACITANCE",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP16",
      "pdfPath": "ncertbookphy16.pdf"
    },
    {
      "id": "ncertbookphy17",
      "name": "3-CURRENT ELECTRICITY",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP17",
      "pdfPath": "ncertbookphy17.pdf"
    },
    {
      "id": "ncertbookphy18",
      "name": "4-MOVING CHARGES AND MAGNETISM",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP18",
      "pdfPath": "ncertbookphy18.pdf"
    },
    {
      "id": "ncertbookphy19",
      "name": "5-MAGNETISM AND MATTER",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP19",
      "pdfPath": "ncertbookphy19.pdf"
    },
    {
      "id": "ncertbookphy20",
      "name": "6-ELECTROMAGNETIC INDUCTION",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP20",
      "pdfPath": "ncertbookphy20.pdf"
    },
    {
      "id": "ncertbookphy21",
      "name": "7-ALTERNATING CURRENT",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP21",
      "pdfPath": "ncertbookphy21.pdf"
    },
    {
      "id": "ncertbookphy22",
      "name": "8-ELECTROMAGNETIC WAVES",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP22",
      "pdfPath": "ncertbookphy22.pdf"
    },
    {
      "id": "ncertbookphy23",
      "name": "9-RAY OPTICS AND OPTICAL INSTRUMENTS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP23",
      "pdfPath": "ncertbookphy23.pdf"
    },
    {
      "id": "ncertbookphy24",
      "name": "10-WAVE OPTICS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP24",
      "pdfPath": "ncertbookphy24.pdf"
    },
    {
      "id": "ncertbookphy25",
      "name": "11-DUAL NATURE OF RADIATION AND MATTER",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP25",
      "pdfPath": "ncertbookphy25.pdf"
    },
    {
      "id": "ncertbookphy26",
      "name": "12-ATOMS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP26",
      "pdfPath": "ncertbookphy26.pdf"
    },
    {
      "id": "ncertbookphy27",
      "name": "13-NUCLEI",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP27",
      "pdfPath": "ncertbookphy27.pdf"
    },
    {
      "id": "ncertbookphy28",
      "name": "14-SEMICONDUCTOR ELECTRONICS",
      "type": "ncertbook",
      "subject": "physics",
      "topic": "CP28",
      "pdfPath": "ncertbookphy28.pdf"
    },


    {
      "id": "ncertbookche1",
      "name": "1-SOME BASIC CONCEPTS OF CHEMISTRY",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "ncertbookche1.pdf"
    },
    {
      "id": "ncertbookche2",
      "name": "2-STRUCTURE OF ATOM",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "ncertbookche2.pdf"
    },
    {
      "id": "ncertbookche3",
      "name": "3-CLASSIFICATION OF ELEMENTS AND PERIODICITY",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "ncertbookche3.pdf"
    },
    {
      "id": "ncertbookche4",
      "name": "4-CHEMICAL BONDING AND MOLECULAR STRUCTURE",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC04",
      "pdfPath": "ncertbookche4.pdf"
    },
    {
      "id": "ncertbookche5",
      "name": "5-THERMODYNAMICS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC05",
      "pdfPath": "ncertbookche5.pdf"
    },
    {
      "id": "ncertbookche6",
      "name": "6-EQUILIBRIUM",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC06",
      "pdfPath": "ncertbookche6.pdf"
    },
    {
      "id": "ncertbookche7",
      "name": "7-REDOX REACTIONS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC07",
      "pdfPath": "ncertbookche7.pdf"
    },
    {
      "id": "ncertbookche8",
      "name": "8-ORGANIC CHEMISTRY – SOME BASIC PRINCIPLES",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC08",
      "pdfPath": "ncertbookche8.pdf"
    },
    {
      "id": "ncertbookche9",
      "name": "9-HYDROCARBONS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC09",
      "pdfPath": "ncertbookche9.pdf"
    },
    {
      "id": "ncertbookche10",
      "name": "1-SOLUTIONS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC10",
      "pdfPath": "ncertbookche10.pdf"
    },
    {
      "id": "ncertbookche11",
      "name": "2-ELECTROCHEMISTRY",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC11",
      "pdfPath": "ncertbookche11.pdf"
    },
    {
      "id": "ncertbookche12",
      "name": "3-CHEMICAL KINETICS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC12",
      "pdfPath": "ncertbookche12.pdf"
    },
    {
      "id": "ncertbookche13",
      "name": "4-D AND F BLOCK ELEMENTS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC13",
      "pdfPath": "ncertbookche13.pdf"
    },
    {
      "id": "ncertbookche14",
      "name": "5-COORDINATION COMPOUNDS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC14",
      "pdfPath": "ncertbookche14.pdf"
    },
    {
      "id": "ncertbookche15",
      "name": "6-HALOALKANES AND HALOARENES",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC15",
      "pdfPath": "ncertbookche15.pdf"
    },
    {
      "id": "ncertbookche16",
      "name": "7-ALCOHOLS, PHENOLS AND ETHERS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC16",
      "pdfPath": "ncertbookche16.pdf"
    },
    {
      "id": "ncertbookche17",
      "name": "8-ALDEHYDES, KETONES AND CARBOXYLIC ACIDS",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC17",
      "pdfPath": "ncertbookche17.pdf"
    },
    {
      "id": "ncertbookche18",
      "name": "9-AMINES",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC18",
      "pdfPath": "ncertbookche18.pdf"
    },
    {
      "id": "ncertbookche19",
      "name": "10-BIOMOLECULES",
      "type": "ncertbook",
      "subject": "chemistry",
      "topic": "CC19",
      "pdfPath": "ncertbookche19.pdf"
    },

    {
      "id": "ncertbookmath1",
      "name": "1-Sets",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "ncertbookmath1.pdf"
    },
    {
      "id": "ncertbookmath2",
      "name": "2-Relations and Functions",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM02",
      "pdfPath": "ncertbookmath2.pdf"
    },
    {
      "id": "ncertbookmath3",
      "name": "3-Trigonometric Functions",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM03",
      "pdfPath": "ncertbookmath3.pdf"
    },
    {
      "id": "ncertbookmath4",
      "name": "4-Complex Numbers and Quadratic Equations",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM04",
      "pdfPath": "ncertbookmath4.pdf"
    },
    {
      "id": "ncertbookmath5",
      "name": "5-Linear Inequalities",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM05",
      "pdfPath": "ncertbookmath5.pdf"
    },
    {
      "id": "ncertbookmath6",
      "name": "6-Permutations and Combinations",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM06",
      "pdfPath": "ncertbookmath6.pdf"
    },
    {
      "id": "ncertbookmath7",
      "name": "7-Binomial Theorem",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM07",
      "pdfPath": "ncertbookmath7.pdf"
    },
    {
      "id": "ncertbookmath8",
      "name": "8-Sequences and Series",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM08",
      "pdfPath": "ncertbookmath8.pdf"
    },
    {
      "id": "ncertbookmath9",
      "name": "9-Straight Lines",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM09",
      "pdfPath": "ncertbookmath9.pdf"
    },
    {
      "id": "ncertbookmath10",
      "name": "10-Conic Sections",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM10",
      "pdfPath": "ncertbookmath10.pdf"
    },
    {
      "id": "ncertbookmath11",
      "name": "11-Introduction to Three Dimensional Geometry",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM11",
      "pdfPath": "ncertbookmath11.pdf"
    },
    {
      "id": "ncertbookmath12",
      "name": "12-Limits and Derivatives",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM12",
      "pdfPath": "ncertbookmath12.pdf"
    },
    {
      "id": "ncertbookmath13",
      "name": "13-Statistics",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM13",
      "pdfPath": "ncertbookmath13.pdf"
    },
    {
      "id": "ncertbookmath14",
      "name": "14-Probability",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM14",
      "pdfPath": "ncertbookmath14.pdf"
    },
    {
      "id": "ncertbookmath15",
      "name": "1-Relations and Functions",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM15",
      "pdfPath": "ncertbookmath15.pdf"
    },
    {
      "id": "ncertbookmath16",
      "name": "2-Inverse Trigonometric Functions",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM16",
      "pdfPath": "ncertbookmath16.pdf"
    },
    {
      "id": "ncertbookmath17",
      "name": "3-Matrices",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM17",
      "pdfPath": "ncertbookmath17.pdf"
    },
    {
      "id": "ncertbookmath18",
      "name": "4-Determinants",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM18",
      "pdfPath": "ncertbookmath18.pdf"
    },
    {
      "id": "ncertbookmath19",
      "name": "5-Continuity and Differentiability",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM19",
      "pdfPath": "ncertbookmath19.pdf"
    },
    {
      "id": "ncertbookmath20",
      "name": "6-Application of Derivatives",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM20",
      "pdfPath": "ncertbookmath20.pdf"
    },
    {
      "id": "ncertbookmath21",
      "name": "7-Integrals",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM21",
      "pdfPath": "ncertbookmath21.pdf"
    },
    {
      "id": "ncertbookmath22",
      "name": "8-Application of Integrals",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM22",
      "pdfPath": "ncertbookmath22.pdf"
    },
    {
      "id": "ncertbookmath23",
      "name": "9-Differential Equations",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM23",
      "pdfPath": "ncertbookmath23.pdf"
    },
    {
      "id": "ncertbookmath24",
      "name": "10-Vector Algebra",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM24",
      "pdfPath": "ncertbookmath24.pdf"
    },
    {
      "id": "ncertbookmath25",
      "name": "11-Three Dimensional Geometry",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM25",
      "pdfPath": "ncertbookmath25.pdf"
    },
    {
      "id": "ncertbookmath26",
      "name": "12-Linear Programming",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM26",
      "pdfPath": "ncertbookmath26.pdf"
    },
    {
      "id": "ncertbookmath27",
      "name": "13-Probability",
      "type": "ncertbook",
      "subject": "math",
      "topic": "CM27",
      "pdfPath": "ncertbookmath27.pdf"
    },



    {
      "id": "mnemonicmath",
      "name": "Math Mnemonics",
      "type": "mnemonic",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "mnemonicmath.pdf"
    },
    {
      "id": "mnemonicphysics",
      "name": "Physics Mnemonics",
      "type": "mnemonic",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "mnemonicphysics.pdf"
    },
    {
      "id": "mnemonicchemistry",
      "name": "Chemistry Mnemonics",
      "type": "mnemonic",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "mnemonicchemistry.pdf"
    },


    {
      "id": "repeatedpyqmath1",
      "name": "1 - Calculus",
      "type": "repeatedpyq",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "repeatedpyqmath1.pdf"
    },
    {
      "id": "repeatedpyqmath2",
      "name": "2 - Trigonometry",
      "type": "repeatedpyq",
      "subject": "math",
      "topic": "CM02",
      "pdfPath": "repeatedpyqmath2.pdf"
    },
    {
      "id": "repeatedpyqmath3",
      "name": "3 - Algebra",
      "type": "repeatedpyq",
      "subject": "math",
      "topic": "CM03",
      "pdfPath": "repeatedpyqmath3.pdf"
    },
    {
      "id": "repeatedpyqmath4",
      "name": "4 - CO-Ordinate geometry",
      "type": "repeatedpyq",
      "subject": "math",
      "topic": "CM04",
      "pdfPath": "repeatedpyqmath4.pdf"
    },

    {
      "id": "repeatedpyqphy1",
      "name": "1 - Mechanics",
      "type": "repeatedpyq",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "repeatedpyqphy1.pdf"
    },
    {
      "id": "repeatedpyqphy2",
      "name": "2 - SHM-Wave, Fluid, Gravitation, Heat",
      "type": "repeatedpyq",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "repeatedpyqphy2.pdf"
    },
    {
      "id": "repeatedpyqphy3",
      "name": "3 - Electromagnetism",
      "type": "repeatedpyq",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "repeatedpyqphy3.pdf"
    },
    {
      "id": "repeatedpyqphy4",
      "name": "4 - Optics",
      "type": "repeatedpyq",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "repeatedpyqphy4.pdf"
    },
    {
      "id": "repeatedpyqphy5",
      "name": "5 - Modern Physics",
      "type": "repeatedpyq",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "repeatedpyqphy5.pdf"
    },

    {
      "id": "repeatedpyqche1",
      "name": "1 - Physical chemistry",
      "type": "repeatedpyq",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "repeatedpyqche1.pdf"
    },
    {
      "id": "repeatedpyqche2",
      "name": "2 - Organic chemistry",
      "type": "repeatedpyq",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "repeatedpyqche2.pdf"
    },
    {
      "id": "repeatedpyqche3",
      "name": "3 - Inorganic chemistry",
      "type": "repeatedpyq",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "repeatedpyqche3.pdf"
    },

    {
      "id": "formulamath1",
      "name": "1 - Exponential series induction",
      "type": "formula",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "formulamath1.pdf"
    },
    {
      "id": "formulamath2",
      "name": "2 - Functions relations",
      "type": "formula",
      "subject": "math",
      "topic": "CM02",
      "pdfPath": "formulamath2.pdf"
    },
    {
      "id": "formulamath3",
      "name": "3 - Trigonometric ratios",
      "type": "formula",
      "subject": "math",
      "topic": "CM03",
      "pdfPath": "formulamath3.pdf"
    },
    {
      "id": "formulamath4",
      "name": "4 - Trigonometric equations",
      "type": "formula",
      "subject": "math",
      "topic": "CM04",
      "pdfPath": "formulamath4.pdf"
    },
    {
      "id": "formulamath5",
      "name": "5 - Properties of triangle",
      "type": "formula",
      "subject": "math",
      "topic": "CM05",
      "pdfPath": "formulamath5.pdf"
    },
    {
      "id": "formulamath6",
      "name": "6 - Height distances",
      "type": "formula",
      "subject": "math",
      "topic": "CM06",
      "pdfPath": "formulamath6.pdf"
    },
    {
      "id": "formulamath7",
      "name": "7 - Quadratic equation",
      "type": "formula",
      "subject": "math",
      "topic": "CM07",
      "pdfPath": "formulamath7.pdf"
    },
    {
      "id": "formulamath8",
      "name": "8 - Complex numbers",
      "type": "formula",
      "subject": "math",
      "topic": "CM08",
      "pdfPath": "formulamath8.pdf"
    },
    {
      "id": "formulamath9",
      "name": "9 - Permutation combination",
      "type": "formula",
      "subject": "math",
      "topic": "CM09",
      "pdfPath": "formulamath9.pdf"
    },
    {
      "id": "formulamath10",
      "name": "10 - Binomial theorem",
      "type": "formula",
      "subject": "math",
      "topic": "CM10",
      "pdfPath": "formulamath10.pdf"
    },
    {
      "id": "formulamath11",
      "name": "11 - Progressions",
      "type": "formula",
      "subject": "math",
      "topic": "CM11",
      "pdfPath": "formulamath11.pdf"
    },
    {
      "id": "formulamath12",
      "name": "12 - Straight line",
      "type": "formula",
      "subject": "math",
      "topic": "CM12",
      "pdfPath": "formulamath12.pdf"
    },
    {
      "id": "formulamath13",
      "name": "13 - Circle",
      "type": "formula",
      "subject": "math",
      "topic": "CM13",
      "pdfPath": "formulamath13.pdf"
    },
    {
      "id": "formulamath14",
      "name": "14 - Parabola",
      "type": "formula",
      "subject": "math",
      "topic": "CM14",
      "pdfPath": "formulamath14.pdf"
    },
    {
      "id": "formulamath15",
      "name": "15 - Ellipse",
      "type": "formula",
      "subject": "math",
      "topic": "CM15",
      "pdfPath": "formulamath15.pdf"
    },
    {
      "id": "formulamath16",
      "name": "16 - Hyperbola",
      "type": "formula",
      "subject": "math",
      "topic": "CM16",
      "pdfPath": "formulamath16.pdf"
    },
    {
      "id": "formulamath17",
      "name": "17 - Limits",
      "type": "formula",
      "subject": "math",
      "topic": "CM17",
      "pdfPath": "formulamath17.pdf"
    },
    {
      "id": "formulamath18",
      "name": "18 - Statistics",
      "type": "formula",
      "subject": "math",
      "topic": "CM18",
      "pdfPath": "formulamath18.pdf"
    },
    {
      "id": "formulamath19",
      "name": "19 - Inverse trigonometric",
      "type": "formula",
      "subject": "math",
      "topic": "CM19",
      "pdfPath": "formulamath19.pdf"
    },
    {
      "id": "formulamath20",
      "name": "20 - Matrices",
      "type": "formula",
      "subject": "math",
      "topic": "CM20",
      "pdfPath": "formulamath20.pdf"
    },
    {
      "id": "formulamath21",
      "name": "21 - Determinants",
      "type": "formula",
      "subject": "math",
      "topic": "CM21",
      "pdfPath": "formulamath21.pdf"
    },
    {
      "id": "formulamath22",
      "name": "22 - Continuity differentiability",
      "type": "formula",
      "subject": "math",
      "topic": "CM22",
      "pdfPath": "formulamath22.pdf"
    },
    {
      "id": "formulamath23",
      "name": "23 - Increasing decreasing maxima minima",
      "type": "formula",
      "subject": "math",
      "topic": "CM23",
      "pdfPath": "formulamath23.pdf"
    },
    {
      "id": "formulamath24",
      "name": "24 - Differentiation",
      "type": "formula",
      "subject": "math",
      "topic": "CM24",
      "pdfPath": "formulamath24.pdf"
    },
    {
      "id": "formulamath25",
      "name": "25 - Tangent normal",
      "type": "formula",
      "subject": "math",
      "topic": "CM25",
      "pdfPath": "formulamath25.pdf"
    },
    {
      "id": "formulamath26",
      "name": "26 - Indefinite integration",
      "type": "formula",
      "subject": "math",
      "topic": "CM26",
      "pdfPath": "formulamath26.pdf"
    },
    {
      "id": "formulamath27",
      "name": "27 - Area",
      "type": "formula",
      "subject": "math",
      "topic": "CM27",
      "pdfPath": "formulamath27.pdf"
    },
    {
      "id": "formulamath28",
      "name": "28 - Vector algebra",
      "type": "formula",
      "subject": "math",
      "topic": "CM28",
      "pdfPath": "formulamath28.pdf"
    },
    {
      "id": "formulamath29",
      "name": "29 - Vector 3d",
      "type": "formula",
      "subject": "math",
      "topic": "CM29",
      "pdfPath": "formulamath29.pdf"
    },
    {
      "id": "formulamath30",
      "name": "30 - Probability",
      "type": "formula",
      "subject": "math",
      "topic": "CM30",
      "pdfPath": "formulamath30.pdf"
    },

    {
      "id": "formulaphy1",
      "name": "1 - Kinematics",
      "type": "formula",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "formulaphy1.pdf"
    },
    {
      "id": "formulaphy2",
      "name": "2 - Motion in 2D",
      "type": "formula",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "formulaphy2.pdf"
    },
    {
      "id": "formulaphy3",
      "name": "3 - Circular motion",
      "type": "formula",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "formulaphy3.pdf"
    },
    {
      "id": "formulaphy4",
      "name": "4 - Laws of motion",
      "type": "formula",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "formulaphy4.pdf"
    },
    {
      "id": "formulaphy5",
      "name": "5 - Work power energy",
      "type": "formula",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "formulaphy5.pdf"
    },
    {
      "id": "formulaphy6",
      "name": "6 - Centre of mass collision",
      "type": "formula",
      "subject": "physics",
      "topic": "CP06",
      "pdfPath": "formulaphy6.pdf"
    },
    {
      "id": "formulaphy7",
      "name": "7 - Rotational motion",
      "type": "formula",
      "subject": "physics",
      "topic": "CP07",
      "pdfPath": "formulaphy7.pdf"
    },
    {
      "id": "formulaphy8",
      "name": "8 - Gravitation",
      "type": "formula",
      "subject": "physics",
      "topic": "CP08",
      "pdfPath": "formulaphy8.pdf"
    },
    {
      "id": "formulaphy9",
      "name": "9 - Elasticity",
      "type": "formula",
      "subject": "physics",
      "topic": "CP09",
      "pdfPath": "formulaphy9.pdf"
    },
    {
      "id": "formulaphy10",
      "name": "10 - Fluid mechanics",
      "type": "formula",
      "subject": "physics",
      "topic": "CP10",
      "pdfPath": "formulaphy10.pdf"
    },
    {
      "id": "formulaphy11",
      "name": "11 - Heat part 1",
      "type": "formula",
      "subject": "physics",
      "topic": "CP11",
      "pdfPath": "formulaphy11.pdf"
    },
    {
      "id": "formulaphy12",
      "name": "12 - Heat part 2",
      "type": "formula",
      "subject": "physics",
      "topic": "CP12",
      "pdfPath": "formulaphy12.pdf"
    },
    {
      "id": "formulaphy13",
      "name": "13 - SHM",
      "type": "formula",
      "subject": "physics",
      "topic": "CP13",
      "pdfPath": "formulaphy13.pdf"
    },
    {
      "id": "formulaphy14",
      "name": "14 - Waves and sound",
      "type": "formula",
      "subject": "physics",
      "topic": "CP14",
      "pdfPath": "formulaphy14.pdf"
    },
    {
      "id": "formulaphy15",
      "name": "15 - Electrostatics",
      "type": "formula",
      "subject": "physics",
      "topic": "CP15",
      "pdfPath": "formulaphy15.pdf"
    },
    {
      "id": "formulaphy16",
      "name": "16 - Capacitor",
      "type": "formula",
      "subject": "physics",
      "topic": "CP16",
      "pdfPath": "formulaphy16.pdf"
    },
    {
      "id": "formulaphy17",
      "name": "17 - Current electricity",
      "type": "formula",
      "subject": "physics",
      "topic": "CP17",
      "pdfPath": "formulaphy17.pdf"
    },
    {
      "id": "formulaphy18",
      "name": "18 - Magnetic effects of current",
      "type": "formula",
      "subject": "physics",
      "topic": "CP18",
      "pdfPath": "formulaphy18.pdf"
    },
    {
      "id": "formulaphy19",
      "name": "19 - Magnetism",
      "type": "formula",
      "subject": "physics",
      "topic": "CP19",
      "pdfPath": "formulaphy19.pdf"
    },
    {
      "id": "formulaphy20",
      "name": "20 - EMI",
      "type": "formula",
      "subject": "physics",
      "topic": "CP20",
      "pdfPath": "formulaphy20.pdf"
    },
    {
      "id": "formulaphy21",
      "name": "21 - Alternating current",
      "type": "formula",
      "subject": "physics",
      "topic": "CP21",
      "pdfPath": "formulaphy21.pdf"
    },
    {
      "id": "formulaphy22",
      "name": "22 - EM waves",
      "type": "formula",
      "subject": "physics",
      "topic": "CP22",
      "pdfPath": "formulaphy22.pdf"
    },
    {
      "id": "formulaphy23",
      "name": "23 - Ray optics",
      "type": "formula",
      "subject": "physics",
      "topic": "CP23",
      "pdfPath": "formulaphy23.pdf"
    },
    {
      "id": "formulaphy24",
      "name": "24 - Optical instruments",
      "type": "formula",
      "subject": "physics",
      "topic": "CP24",
      "pdfPath": "formulaphy24.pdf"
    },
    {
      "id": "formulaphy25",
      "name": "25 - Wave optics",
      "type": "formula",
      "subject": "physics",
      "topic": "CP25",
      "pdfPath": "formulaphy25.pdf"
    },
    {
      "id": "formulaphy26",
      "name": "26 - Modern physics",
      "type": "formula",
      "subject": "physics",
      "topic": "CP26",
      "pdfPath": "formulaphy26.pdf"
    },
    {
      "id": "formulaphy27",
      "name": "27 - Logic gates",
      "type": "formula",
      "subject": "physics",
      "topic": "CP27",
      "pdfPath": "formulaphy27.pdf"
    },
    {
      "id": "formulaphy28",
      "name": "28 - Semiconductors",
      "type": "formula",
      "subject": "physics",
      "topic": "CP28",
      "pdfPath": "formulaphy28.pdf"
    },

    {
      "id": "formulache1",
      "name": "1 - Some basic concepts of chemistry",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "formulache1.pdf"
    },
    {
      "id": "formulache2",
      "name": "2 - Atomic structure",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "formulache2.pdf"
    },
    {
      "id": "formulache3",
      "name": "3 - Periodic properties",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "formulache3.pdf"
    },
    {
      "id": "formulache4",
      "name": "4 - Chemical bonding",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC04",
      "pdfPath": "formulache4.pdf"
    },
    {
      "id": "formulache5",
      "name": "5 - States of matter",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC05",
      "pdfPath": "formulache5.pdf"
    },
    {
      "id": "formulache6",
      "name": "6 - Thermodynamics",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC06",
      "pdfPath": "formulache6.pdf"
    },
    {
      "id": "formulache7",
      "name": "7 - Chemical equilibrium",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC07",
      "pdfPath": "formulache7.pdf"
    },
    {
      "id": "formulache8",
      "name": "8 - Ionic equilibrium",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC08",
      "pdfPath": "formulache8.pdf"
    },
    {
      "id": "formulache9",
      "name": "9 - Hydrogen",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC09",
      "pdfPath": "formulache9.pdf"
    },
    {
      "id": "formulache10",
      "name": "10 - S block",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC10",
      "pdfPath": "formulache10.pdf"
    },
    {
      "id": "formulache11",
      "name": "11 - P block",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC11",
      "pdfPath": "formulache11.pdf"
    },
    {
      "id": "formulache12",
      "name": "12 - Nomenclature",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC12",
      "pdfPath": "formulache12.pdf"
    },
    {
      "id": "formulache13",
      "name": "13 - General organic chemistry",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC13",
      "pdfPath": "formulache13.pdf"
    },
    {
      "id": "formulache14",
      "name": "14 - Mechanisms basics",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC14",
      "pdfPath": "formulache14.pdf"
    },
    {
      "id": "formulache15",
      "name": "15 - Isomerism",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC15",
      "pdfPath": "formulache15.pdf"
    },
    {
      "id": "formulache16",
      "name": "16 - Hydrocarbons",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC16",
      "pdfPath": "formulache16.pdf"
    },
    {
      "id": "formulache17",
      "name": "17 - Environmental chemistry",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC17",
      "pdfPath": "formulache17.pdf"
    },
    {
      "id": "formulache18",
      "name": "18 - Solid state",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC18",
      "pdfPath": "formulache18.pdf"
    },
    {
      "id": "formulache19",
      "name": "19 - Solution",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC19",
      "pdfPath": "formulache19.pdf"
    },
    {
      "id": "formulache20",
      "name": "20 - Electrochemistry",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC20",
      "pdfPath": "formulache20.pdf"
    },
    {
      "id": "formulache21",
      "name": "21 - Chemical kinetics",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC21",
      "pdfPath": "formulache21.pdf"
    },
    {
      "id": "formulache22",
      "name": "22 - Surface chemistry",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC22",
      "pdfPath": "formulache22.pdf"
    },
    {
      "id": "formulache23",
      "name": "23 - Metallurgy",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC23",
      "pdfPath": "formulache23.pdf"
    },
    {
      "id": "formulache24",
      "name": "24 - D and f block elements",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC24",
      "pdfPath": "formulache24.pdf"
    },
    {
      "id": "formulache25",
      "name": "25 - Coordination compounds",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC25",
      "pdfPath": "formulache25.pdf"
    },
    {
      "id": "formulache26",
      "name": "26 - Halogen derivatives",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC26",
      "pdfPath": "formulache26.pdf"
    },
    {
      "id": "formulache27",
      "name": "27 - Alcohol phenol ether",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC27",
      "pdfPath": "formulache27.pdf"
    },
    {
      "id": "formulache28",
      "name": "28 - Aldehydes ketones",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC28",
      "pdfPath": "formulache28.pdf"
    },
    {
      "id": "formulache29",
      "name": "29 - Carboxylic acids",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC29",
      "pdfPath": "formulache29.pdf"
    },
    {
      "id": "formulache30",
      "name": "30 - Amines",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC30",
      "pdfPath": "formulache30.pdf"
    },
    {
      "id": "formulache31",
      "name": "31 - Biomolecules",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC31",
      "pdfPath": "formulache31.pdf"
    },
    {
      "id": "formulache32",
      "name": "32 - Polymer",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC32",
      "pdfPath": "formulache32.pdf"
    },
    {
      "id": "formulache33",
      "name": "33 - Chemistry in everyday life",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC33",
      "pdfPath": "formulache33.pdf"
    },
    {
      "id": "formulache34",
      "name": "34 - Qualitative analysis",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC34",
      "pdfPath": "formulache34.pdf"
    },



    {
      "id": "mindmapmath1",
      "name": "1 - Functions",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "mindmapmath1.pdf"
    },
    {
      "id": "mindmapmath2",
      "name": "2 - Relations",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM02",
      "pdfPath": "mindmapmath2.pdf"
    },
    {
      "id": "mindmapmath3",
      "name": "3 - Limit",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM03",
      "pdfPath": "mindmapmath3.pdf"
    },
    {
      "id": "mindmapmath4",
      "name": "4 - Continuity & Differentiability",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM04",
      "pdfPath": "mindmapmath4.pdf"
    },
    {
      "id": "mindmapmath5",
      "name": "5 - Differentiation",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM05",
      "pdfPath": "mindmapmath5.pdf"
    },
    {
      "id": "mindmapmath6",
      "name": "6 - Application of Derivatives",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM06",
      "pdfPath": "mindmapmath6.pdf"
    },
    {
      "id": "mindmapmath7",
      "name": "7 - Indefinite Integration",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM07",
      "pdfPath": "mindmapmath7.pdf"
    },
    {
      "id": "mindmapmath8",
      "name": "8 - Definite Integration & AOI",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM08",
      "pdfPath": "mindmapmath8.pdf"
    },
    {
      "id": "mindmapmath9",
      "name": "9 - Differential Equations",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM09",
      "pdfPath": "mindmapmath9.pdf"
    },
    {
      "id": "mindmapmath10",
      "name": "10 - Inverse Trigonometric Functions",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM10",
      "pdfPath": "mindmapmath10.pdf"
    },
    {
      "id": "mindmapmath11",
      "name": "11 - Matrices",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM11",
      "pdfPath": "mindmapmath11.pdf"
    },
    {
      "id": "mindmapmath12",
      "name": "12 - Determinant",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM12",
      "pdfPath": "mindmapmath12.pdf"
    },
    {
      "id": "mindmapmath13",
      "name": "13 - Vectors Algebra",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM13",
      "pdfPath": "mindmapmath13.pdf"
    },
    {
      "id": "mindmapmath14",
      "name": "14 - Probability",
      "type": "mindmap",
      "subject": "math",
      "topic": "CM14",
      "pdfPath": "mindmapmath14.pdf"
    },

    {
      "id": "mindmapphy1",
      "name": "1 - Electric Charges and Fields",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "mindmapphy1.pdf"
    },
    {
      "id": "mindmapphy2",
      "name": "2 - Electrostatic",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "mindmapphy2.pdf"
    },
    {
      "id": "mindmapphy3",
      "name": "3 - Capacitance",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "mindmapphy3.pdf"
    },
    {
      "id": "mindmapphy4",
      "name": "4 - Current Electricity",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "mindmapphy4.pdf"
    },
    {
      "id": "mindmapphy5",
      "name": "5 - Moving Charges & Magnetism",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "mindmapphy5.pdf"
    },
    {
      "id": "mindmapphy6",
      "name": "6 - Magnetism & Matter",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP06",
      "pdfPath": "mindmapphy6.pdf"
    },
    {
      "id": "mindmapphy7",
      "name": "7 - Electromagnetic Induction",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP07",
      "pdfPath": "mindmapphy7.pdf"
    },
    {
      "id": "mindmapphy8",
      "name": "8 - Alternating Current",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP08",
      "pdfPath": "mindmapphy8.pdf"
    },
    {
      "id": "mindmapphy9",
      "name": "9 - Electromagnetic Waves",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP09",
      "pdfPath": "mindmapphy9.pdf"
    },
    {
      "id": "mindmapphy10",
      "name": "10 - Ray Optics",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP10",
      "pdfPath": "mindmapphy10.pdf"
    },
    {
      "id": "mindmapphy11",
      "name": "11 - Wave Optics",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP11",
      "pdfPath": "mindmapphy11.pdf"
    },
    {
      "id": "mindmapphy12",
      "name": "12 - Dual Nature of Matter & Radiation",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP12",
      "pdfPath": "mindmapphy12.pdf"
    },
    {
      "id": "mindmapphy13",
      "name": "13 - Atoms",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP13",
      "pdfPath": "mindmapphy13.pdf"
    },
    {
      "id": "mindmapphy14",
      "name": "14 - Nuclei",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP14",
      "pdfPath": "mindmapphy14.pdf"
    },
    {
      "id": "mindmapphy15",
      "name": "15 - Semiconductors",
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP15",
      "pdfPath": "mindmapphy15.pdf"
    },

    {
      "id": "mindmapche1",
      "name": "1 - Solid State",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "mindmapche1.pdf"
    },
    {
      "id": "mindmapche2",
      "name": "2 - Solution",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "mindmapche2.pdf"
    },
    {
      "id": "mindmapche3",
      "name": "3 - Electrochemistry",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "mindmapche3.pdf"
    },
    {
      "id": "mindmapche4",
      "name": "4 - Chemical Kinetics",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC04",
      "pdfPath": "mindmapche4.pdf"
    },
    {
      "id": "mindmapche5",
      "name": "5 - Surface Chemistry",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC05",
      "pdfPath": "mindmapche5.pdf"
    },
    {
      "id": "mindmapche6",
      "name": "6 - The p-Block Elements",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC06",
      "pdfPath": "mindmapche6.pdf"
    },
    {
      "id": "mindmapche7",
      "name": "7 - Coordination Compounds",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC07",
      "pdfPath": "mindmapche7.pdf"
    },
    {
      "id": "mindmapche8",
      "name": "8 - Metallurgy",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC08",
      "pdfPath": "mindmapche8.pdf"
    },
    {
      "id": "mindmapche9",
      "name": "9 - ACYL (ACID) Chloride",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC09",
      "pdfPath": "mindmapche9.pdf"
    },
    {
      "id": "mindmapche10",
      "name": "10 - Alcohols",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC10",
      "pdfPath": "mindmapche10.pdf"
    },
    {
      "id": "mindmapche11",
      "name": "11 - Phenol",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC11",
      "pdfPath": "mindmapche11.pdf"
    },
    {
      "id": "mindmapche12",
      "name": "12 - Ketones",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC12",
      "pdfPath": "mindmapche12.pdf"
    },
    {
      "id": "mindmapche13",
      "name": "13 - Esters",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC13",
      "pdfPath": "mindmapche13.pdf"
    },
    {
      "id": "mindmapche14",
      "name": "14 - Amine",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC14",
      "pdfPath": "mindmapche14.pdf"
    },
    {
      "id": "mindmapche15",
      "name": "15 - Polymer",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC15",
      "pdfPath": "mindmapche15.pdf"
    },
    {
      "id": "mindmapche16",
      "name": "16 - Biomolecules",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC16",
      "pdfPath": "mindmapche16.pdf"
    },
    {
      "id": "mindmapche17",
      "name": "17 - Chemistry In Everyday Life",
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC17",
      "pdfPath": "mindmapche17.pdf"
    },



    {
      "id": "flashcardmath1",
      "name": "1 - Permutations and Combinations",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "flashcardmath1.pdf"
    },
    {
      "id": "flashcardmath2",
      "name": "2 - Binomial Theorem",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM02",
      "pdfPath": "flashcardmath2.pdf"
    },
    {
      "id": "flashcardmath3",
      "name": "3 - Probability",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM03",
      "pdfPath": "flashcardmath3.pdf"
    },
    {
      "id": "flashcardmath4",
      "name": "4 - Squence and Series",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM04",
      "pdfPath": "flashcardmath4.pdf"
    },
    {
      "id": "flashcardmath5",
      "name": "5 - Harmonic Progression and Mics.",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM05",
      "pdfPath": "flashcardmath5.pdf"
    },
    {
      "id": "flashcardmath6",
      "name": "6 - Statistics",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM06",
      "pdfPath": "flashcardmath6.pdf"
    },
    {
      "id": "flashcardmath7",
      "name": "7 - Inverse Trigonometric Functions",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM07",
      "pdfPath": "flashcardmath7.pdf"
    },
    {
      "id": "flashcardmath8",
      "name": "8 - Limits",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM08",
      "pdfPath": "flashcardmath8.pdf"
    },
    {
      "id": "flashcardmath9",
      "name": "9 - What is a Matrix",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM09",
      "pdfPath": "flashcardmath9.pdf"
    },
    {
      "id": "flashcardmath10",
      "name": "10 - Determinant",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM10",
      "pdfPath": "flashcardmath10.pdf"
    },
    {
      "id": "flashcardmath11",
      "name": "11 - 2D - Shapes",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM11",
      "pdfPath": "flashcardmath11.pdf"
    },
    {
      "id": "flashcardmath12",
      "name": "12 - 3D - Shapes",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM12",
      "pdfPath": "flashcardmath12.pdf"
    },
    {
      "id": "flashcardmath13",
      "name": "13 - Point in 2D Cartesian System",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM13",
      "pdfPath": "flashcardmath13.pdf"
    },
    {
      "id": "flashcardmath14",
      "name": "14 - Straight Line",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM14",
      "pdfPath": "flashcardmath14.pdf"
    },
    {
      "id": "flashcardmath15",
      "name": "15 - Circle Properties",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM15",
      "pdfPath": "flashcardmath15.pdf"
    },
    {
      "id": "flashcardmath16",
      "name": "16 - Set",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM16",
      "pdfPath": "flashcardmath16.pdf"
    },
    {
      "id": "flashcardmath17",
      "name": "17 - Functions",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM17",
      "pdfPath": "flashcardmath17.pdf"
    },
    {
      "id": "flashcardmath18",
      "name": "18 - Special Functions",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM18",
      "pdfPath": "flashcardmath18.pdf"
    },
    {
      "id": "flashcardmath19",
      "name": "19 - Trigonometry Ratio",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM19",
      "pdfPath": "flashcardmath19.pdf"
    },
    {
      "id": "flashcardmath20",
      "name": "20 - Trigonometric Identities",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM20",
      "pdfPath": "flashcardmath20.pdf"
    },
    {
      "id": "flashcardmath21",
      "name": "21 - Trigonometric Equation",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM21",
      "pdfPath": "flashcardmath21.pdf"
    },
    {
      "id": "flashcardmath22",
      "name": "22 - Solution of Triangle",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM22",
      "pdfPath": "flashcardmath22.pdf"
    },
    {
      "id": "flashcardmath23",
      "name": "23 - Vector",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM23",
      "pdfPath": "flashcardmath23.pdf"
    },
    {
      "id": "flashcardmath24",
      "name": "24 - 3D Coordinate Geometry",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM24",
      "pdfPath": "flashcardmath24.pdf"
    },
    {
      "id": "flashcardmath25",
      "name": "25 - Complex Number",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM25",
      "pdfPath": "flashcardmath25.pdf"
    },
    {
      "id": "flashcardmath26",
      "name": "26 - Complex Theorem",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM26",
      "pdfPath": "flashcardmath26.pdf"
    },
    {
      "id": "flashcardmath27",
      "name": "27 - Continuity",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM27",
      "pdfPath": "flashcardmath27.pdf"
    },
    {
      "id": "flashcardmath28",
      "name": "28 - Differentiability",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM28",
      "pdfPath": "flashcardmath28.pdf"
    },
    {
      "id": "flashcardmath29",
      "name": "29 - Derivative",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM29",
      "pdfPath": "flashcardmath29.pdf"
    },
    {
      "id": "flashcardmath30",
      "name": "30 - Indefinite Integral",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM30",
      "pdfPath": "flashcardmath30.pdf"
    },
    {
      "id": "flashcardmath31",
      "name": "31 - Definite Integrals",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM31",
      "pdfPath": "flashcardmath31.pdf"
    },
    {
      "id": "flashcardmath32",
      "name": "32 - Tangent and Normal",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM32",
      "pdfPath": "flashcardmath32.pdf"
    },
    {
      "id": "flashcardmath33",
      "name": "33 - Monotonocity",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM33",
      "pdfPath": "flashcardmath33.pdf"
    },
    {
      "id": "flashcardmath34",
      "name": "34 - Maxima and Minima",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM34",
      "pdfPath": "flashcardmath34.pdf"
    },
    {
      "id": "flashcardmath35",
      "name": "35 - Area Under the Curve",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM35",
      "pdfPath": "flashcardmath35.pdf"
    },
    {
      "id": "flashcardmath36",
      "name": "36 - Differential Equation",
      "type": "flashcard",
      "subject": "math",
      "topic": "CM36",
      "pdfPath": "flashcardmath36.pdf"
    },

    {
      "id": "flashcardphy1",
      "name": "1 - Units",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "flashcardphy1.pdf"
    },
    {
      "id": "flashcardphy2",
      "name": "2 - Dimensions",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "flashcardphy2.pdf"
    },
    {
      "id": "flashcardphy3",
      "name": "3 - Error",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "flashcardphy3.pdf"
    },
    {
      "id": "flashcardphy4",
      "name": "4 - Rest and Motion",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "flashcardphy4.pdf"
    },
    {
      "id": "flashcardphy5",
      "name": "5 - Motion Under Gravity",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "flashcardphy5.pdf"
    },
    {
      "id": "flashcardphy6",
      "name": "6 - Rectilinear Motion Cases",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP06",
      "pdfPath": "flashcardphy6.pdf"
    },
    {
      "id": "flashcardphy7",
      "name": "7 - Displacement, Velocity & Acceleration Graph",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP07",
      "pdfPath": "flashcardphy7.pdf"
    },
    {
      "id": "flashcardphy8",
      "name": "8 - Relative Velocity",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP08",
      "pdfPath": "flashcardphy8.pdf"
    },
    {
      "id": "flashcardphy9",
      "name": "9 - Projectile Motion",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP09",
      "pdfPath": "flashcardphy9.pdf"
    },
    {
      "id": "flashcardphy10",
      "name": "10 - Force and its Type",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP10",
      "pdfPath": "flashcardphy10.pdf"
    },
    {
      "id": "flashcardphy11",
      "name": "11 - Laws of Motion",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP11",
      "pdfPath": "flashcardphy11.pdf"
    },
    {
      "id": "flashcardphy12",
      "name": "12 - Pulley Block System",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP12",
      "pdfPath": "flashcardphy12.pdf"
    },
    {
      "id": "flashcardphy13",
      "name": "13 - Friction",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP13",
      "pdfPath": "flashcardphy13.pdf"
    },
    {
      "id": "flashcardphy14",
      "name": "14 - Circular Motion",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP14",
      "pdfPath": "flashcardphy14.pdf"
    },
    {
      "id": "flashcardphy15",
      "name": "15 - Circular Turning on Roads",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP15",
      "pdfPath": "flashcardphy15.pdf"
    },
    {
      "id": "flashcardphy16",
      "name": "16 - Motorcycle on a Curved Path",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP16",
      "pdfPath": "flashcardphy16.pdf"
    },
    {
      "id": "flashcardphy17",
      "name": "17 - Work, Power, Energy",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP17",
      "pdfPath": "flashcardphy17.pdf"
    },
    {
      "id": "flashcardphy18",
      "name": "18 - Vertical Circular Motion",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP18",
      "pdfPath": "flashcardphy18.pdf"
    },
    {
      "id": "flashcardphy19",
      "name": "19 - Centre of Mass of Some Common System",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP19",
      "pdfPath": "flashcardphy19.pdf"
    },
    {
      "id": "flashcardphy20",
      "name": "20 - Spring Force",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP20",
      "pdfPath": "flashcardphy20.pdf"
    },
    {
      "id": "flashcardphy21",
      "name": "21 - Impulse and Momentum",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP21",
      "pdfPath": "flashcardphy21.pdf"
    },
    {
      "id": "flashcardphy22",
      "name": "22 - Angular Momentum",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP22",
      "pdfPath": "flashcardphy22.pdf"
    },
    {
      "id": "flashcardphy23",
      "name": "23 - Gravitation",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP23",
      "pdfPath": "flashcardphy23.pdf"
    },
    {
      "id": "flashcardphy24",
      "name": "24 - Elasticity",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP24",
      "pdfPath": "flashcardphy24.pdf"
    },
    {
      "id": "flashcardphy25",
      "name": "25 - Fluid Mechanics",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP25",
      "pdfPath": "flashcardphy25.pdf"
    },
    {
      "id": "flashcardphy26",
      "name": "26 - Radiation Conduction",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP26",
      "pdfPath": "flashcardphy26.pdf"
    },
    {
      "id": "flashcardphy27",
      "name": "27 - The Gas Laws",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP27",
      "pdfPath": "flashcardphy27.pdf"
    },
    {
      "id": "flashcardphy28",
      "name": "28 - Simple Harmonic Motion",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP28",
      "pdfPath": "flashcardphy28.pdf"
    },
    {
      "id": "flashcardphy29",
      "name": "29 - Wave",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP29",
      "pdfPath": "flashcardphy29.pdf"
    },
    {
      "id": "flashcardphy30",
      "name": "30 - Superposition and Standing Waves",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP30",
      "pdfPath": "flashcardphy30.pdf"
    },
    {
      "id": "flashcardphy31",
      "name": "31 - Sound Wave",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP31",
      "pdfPath": "flashcardphy31.pdf"
    },
    {
      "id": "flashcardphy32",
      "name": "32 - Doppler Effect",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP32",
      "pdfPath": "flashcardphy32.pdf"
    },
    {
      "id": "flashcardphy33",
      "name": "33 - Electric Field",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP33",
      "pdfPath": "flashcardphy33.pdf"
    },
    {
      "id": "flashcardphy34",
      "name": "34 - Electric Flux",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP34",
      "pdfPath": "flashcardphy34.pdf"
    },
    {
      "id": "flashcardphy35",
      "name": "35 - Capacitor",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP35",
      "pdfPath": "flashcardphy35.pdf"
    },
    {
      "id": "flashcardphy36",
      "name": "36 - Circuit Solution",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP36",
      "pdfPath": "flashcardphy36.pdf"
    },
    {
      "id": "flashcardphy37",
      "name": "37 - Resistance",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP37",
      "pdfPath": "flashcardphy37.pdf"
    },
    {
      "id": "flashcardphy38",
      "name": "38 - Grouping of Cells",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP38",
      "pdfPath": "flashcardphy38.pdf"
    },
    {
      "id": "flashcardphy39",
      "name": "39 - Cells and Electric Power",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP39",
      "pdfPath": "flashcardphy39.pdf"
    },
    {
      "id": "flashcardphy40",
      "name": "40 - Instruments Measuring Various Electrical Quantities",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP40",
      "pdfPath": "flashcardphy40.pdf"
    },
    {
      "id": "flashcardphy41",
      "name": "41 - Magnetic Field",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP41",
      "pdfPath": "flashcardphy41.pdf"
    },
    {
      "id": "flashcardphy42",
      "name": "42 - Magnetic Property",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP42",
      "pdfPath": "flashcardphy42.pdf"
    },
    {
      "id": "flashcardphy43",
      "name": "43 - Self Induction",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP43",
      "pdfPath": "flashcardphy43.pdf"
    },
    {
      "id": "flashcardphy44",
      "name": "44 - Alternating Current",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP44",
      "pdfPath": "flashcardphy44.pdf"
    },
    {
      "id": "flashcardphy45",
      "name": "45 - Mirrors",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP45",
      "pdfPath": "flashcardphy45.pdf"
    },
    {
      "id": "flashcardphy46",
      "name": "46 - Wave Optics",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP46",
      "pdfPath": "flashcardphy46.pdf"
    },
    {
      "id": "flashcardphy47",
      "name": "47 - Photoelectric Effect",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP47",
      "pdfPath": "flashcardphy47.pdf"
    },
    {
      "id": "flashcardphy48",
      "name": "48 - History of Atomic Model",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP48",
      "pdfPath": "flashcardphy48.pdf"
    },
    {
      "id": "flashcardphy49",
      "name": "49 - Nuclear Physics",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP49",
      "pdfPath": "flashcardphy49.pdf"
    },
    {
      "id": "flashcardphy50",
      "name": "50 - Semiconductor",
      "type": "flashcard",
      "subject": "physics",
      "topic": "CP50",
      "pdfPath": "flashcardphy50.pdf"
    },

    {
      "id": "flashcardche1",
      "name": "1 - Concentration Terms",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "flashcardche1.pdf"
    },
    {
      "id": "flashcardche2",
      "name": "2 - Equivalent Mass",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "flashcardche2.pdf"
    },
    {
      "id": "flashcardche3",
      "name": "3 - Chemical Reactions",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "flashcardche3.pdf"
    },
    {
      "id": "flashcardche4",
      "name": "4 - History of Atomic Model",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC04",
      "pdfPath": "flashcardche4.pdf"
    },
    {
      "id": "flashcardche5",
      "name": "5 - Hydrogen Spectrum",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC05",
      "pdfPath": "flashcardche5.pdf"
    },
    {
      "id": "flashcardche6",
      "name": "6 - Quantum Number",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC06",
      "pdfPath": "flashcardche6.pdf"
    },
    {
      "id": "flashcardche7",
      "name": "7 - Ionic Compounds",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC07",
      "pdfPath": "flashcardche7.pdf"
    },
    {
      "id": "flashcardche8",
      "name": "8 - Molecular Compounds",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC08",
      "pdfPath": "flashcardche8.pdf"
    },
    {
      "id": "flashcardche9",
      "name": "9 - Hybridisation",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC09",
      "pdfPath": "flashcardche9.pdf"
    },
    {
      "id": "flashcardche10",
      "name": "10 - VSEPR and Shapes of Molecules",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC10",
      "pdfPath": "flashcardche10.pdf"
    },
    {
      "id": "flashcardche11",
      "name": "11 - Molecular Orbital Theory",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC11",
      "pdfPath": "flashcardche11.pdf"
    },
    {
      "id": "flashcardche12",
      "name": "12 - Gas Laws",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC12",
      "pdfPath": "flashcardche12.pdf"
    },
    {
      "id": "flashcardche13",
      "name": "13 - What Makes Gases Real",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC13",
      "pdfPath": "flashcardche13.pdf"
    },
    {
      "id": "flashcardche14",
      "name": "14 - Distribution of Molecular Velocities",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC14",
      "pdfPath": "flashcardche14.pdf"
    },
    {
      "id": "flashcardche15",
      "name": "15 - Thermodynamics",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC15",
      "pdfPath": "flashcardche15.pdf"
    },
    {
      "id": "flashcardche16",
      "name": "16 - Exothermic vs Endothermic",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC16",
      "pdfPath": "flashcardche16.pdf"
    },
    {
      "id": "flashcardche17",
      "name": "17 - Carnot Cycle",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC17",
      "pdfPath": "flashcardche17.pdf"
    },
    {
      "id": "flashcardche18",
      "name": "18 - Chemical Equilibrium",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC18",
      "pdfPath": "flashcardche18.pdf"
    },
    {
      "id": "flashcardche19",
      "name": "19 - It's Le Chatelier's Principle",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC19",
      "pdfPath": "flashcardche19.pdf"
    },
    {
      "id": "flashcardche20",
      "name": "20 - States of Matter",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC20",
      "pdfPath": "flashcardche20.pdf"
    },
    {
      "id": "flashcardche21",
      "name": "21 - Bravais Lattices of Crystals",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC21",
      "pdfPath": "flashcardche21.pdf"
    },
    {
      "id": "flashcardche22",
      "name": "22 - Raoult's Law",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC22",
      "pdfPath": "flashcardche22.pdf"
    },
    {
      "id": "flashcardche23",
      "name": "23 - Colligative Property",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC23",
      "pdfPath": "flashcardche23.pdf"
    },
    {
      "id": "flashcardche24",
      "name": "24 - Osmotic Pressure and Vant Hoff Factor",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC24",
      "pdfPath": "flashcardche24.pdf"
    },
    {
      "id": "flashcardche25",
      "name": "25 - Boron Family",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC25",
      "pdfPath": "flashcardche25.pdf"
    },
    {
      "id": "flashcardche26",
      "name": "26 - Carbon Family",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC26",
      "pdfPath": "flashcardche26.pdf"
    },
    {
      "id": "flashcardche27",
      "name": "27 - Nitrogen Family",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC27",
      "pdfPath": "flashcardche27.pdf"
    },
    {
      "id": "flashcardche28",
      "name": "28 - Chalcogens",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC28",
      "pdfPath": "flashcardche28.pdf"
    },
    {
      "id": "flashcardche29",
      "name": "29 - Halogens",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC29",
      "pdfPath": "flashcardche29.pdf"
    },
    {
      "id": "flashcardche30",
      "name": "30 - Noble Gases",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC30",
      "pdfPath": "flashcardche30.pdf"
    },
    {
      "id": "flashcardche31",
      "name": "31 - Isomerism in Coordination Compounds",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC31",
      "pdfPath": "flashcardche31.pdf"
    },
    {
      "id": "flashcardche32",
      "name": "32 - Crystal Field Theory",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC32",
      "pdfPath": "flashcardche32.pdf"
    },
    {
      "id": "flashcardche33",
      "name": "33 - Chemical Kinetics",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC33",
      "pdfPath": "flashcardche33.pdf"
    },
    {
      "id": "flashcardche34",
      "name": "34 - Order of Reaction",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC34",
      "pdfPath": "flashcardche34.pdf"
    },
    {
      "id": "flashcardche35",
      "name": "35 - Radio Activity",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC35",
      "pdfPath": "flashcardche35.pdf"
    },
    {
      "id": "flashcardche36",
      "name": "36 - Electrochemistry",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC36",
      "pdfPath": "flashcardche36.pdf"
    },
    {
      "id": "flashcardche37",
      "name": "37 - Salt Analysis",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC37",
      "pdfPath": "flashcardche37.pdf"
    },
    {
      "id": "flashcardche38",
      "name": "38 - Facts About Alkanes",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC38",
      "pdfPath": "flashcardche38.pdf"
    },
    {
      "id": "flashcardche39",
      "name": "39 - Alcohols",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC39",
      "pdfPath": "flashcardche39.pdf"
    },
    {
      "id": "flashcardche40",
      "name": "40 - Ethers",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC40",
      "pdfPath": "flashcardche40.pdf"
    },
    {
      "id": "flashcardche41",
      "name": "41 - Substitution Reaction",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC41",
      "pdfPath": "flashcardche41.pdf"
    },
    {
      "id": "flashcardche42",
      "name": "42 - Grignard Reagent",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC42",
      "pdfPath": "flashcardche42.pdf"
    },
    {
      "id": "flashcardche43",
      "name": "43 - Aldehyde and Ketones",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC43",
      "pdfPath": "flashcardche43.pdf"
    },
    {
      "id": "flashcardche44",
      "name": "44 - Carboxylic Acids",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC44",
      "pdfPath": "flashcardche44.pdf"
    },
    {
      "id": "flashcardche45",
      "name": "45 - Amines",
      "type": "flashcard",
      "subject": "chemistry",
      "topic": "CC45",
      "pdfPath": "flashcardche45.pdf"
    },


    {
      "id": "toppernotemath1",
      "name": "1 - Complex Numbers",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM01",
      "pdfPath": "toppernotemath1.pdf"
    },
    {
      "id": "toppernotemath2",
      "name": "2 - Determinants & Matrix",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM02",
      "pdfPath": "toppernotemath2.pdf"
    },
    {
      "id": "toppernotemath3",
      "name": "3 - Permutation & Combination",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM03",
      "pdfPath": "toppernotemath3.pdf"
    },
    {
      "id": "toppernotemath4",
      "name": "4 - Inequalities & Graphs",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM04",
      "pdfPath": "toppernotemath4.pdf"
    },
    {
      "id": "toppernotemath5",
      "name": "5 - Binomial Theorem",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM05",
      "pdfPath": "toppernotemath5.pdf"
    },
    {
      "id": "toppernotemath6",
      "name": "6 - Inverse Trigonometry Functions",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM06",
      "pdfPath": "toppernotemath6.pdf"
    },
    {
      "id": "toppernotemath7",
      "name": "7 - Solution OF Triangle",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM07",
      "pdfPath": "toppernotemath7.pdf"
    },
    {
      "id": "toppernotemath8",
      "name": "8 - Straight Lines",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM08",
      "pdfPath": "toppernotemath8.pdf"
    },
    {
      "id": "toppernotemath9",
      "name": "9 - Circle",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM09",
      "pdfPath": "toppernotemath9.pdf"
    },
    {
      "id": "toppernotemath10",
      "name": "10 - Parabola",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM10",
      "pdfPath": "toppernotemath10.pdf"
    },
    {
      "id": "toppernotemath11",
      "name": "11 - Ellipse",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM11",
      "pdfPath": "toppernotemath11.pdf"
    },
    {
      "id": "toppernotemath12",
      "name": "12 - Hyperbola",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM12",
      "pdfPath": "toppernotemath12.pdf"
    },
    {
      "id": "toppernotemath13",
      "name": "13 - Vectors",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM13",
      "pdfPath": "toppernotemath13.pdf"
    },
    {
      "id": "toppernotemath14",
      "name": "14 - 3D-Geometry",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM14",
      "pdfPath": "toppernotemath14.pdf"
    },
    {
      "id": "toppernotemath15",
      "name": "15 - Function",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM15",
      "pdfPath": "toppernotemath15.pdf"
    },
    {
      "id": "toppernotemath16",
      "name": "16 - Limits",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM16",
      "pdfPath": "toppernotemath16.pdf"
    },
    {
      "id": "toppernotemath17",
      "name": "17 - Continuity OF Functions",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM17",
      "pdfPath": "toppernotemath17.pdf"
    },
    {
      "id": "toppernotemath18",
      "name": "18 - Differentiability",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM18",
      "pdfPath": "toppernotemath18.pdf"
    },
    {
      "id": "toppernotemath19",
      "name": "19 - Tangent & Normal",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM19",
      "pdfPath": "toppernotemath19.pdf"
    },
    {
      "id": "toppernotemath20",
      "name": "20 - Monotonicity",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM20",
      "pdfPath": "toppernotemath20.pdf"
    },
    {
      "id": "toppernotemath21",
      "name": "21 - Rolle's Theorem",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM21",
      "pdfPath": "toppernotemath21.pdf"
    },
    {
      "id": "toppernotemath22",
      "name": "22 - Indefinit Integration",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM22",
      "pdfPath": "toppernotemath22.pdf"
    },
    {
      "id": "toppernotemath23",
      "name": "23 - Definite Integration",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM23",
      "pdfPath": "toppernotemath23.pdf"
    },
    {
      "id": "toppernotemath24",
      "name": "24 - Area Under Curve",
      "type": "toppernote",
      "subject": "math",
      "topic": "CM24",
      "pdfPath": "toppernotemath24.pdf"
    },

    {
      "id": "toppernotephy1",
      "name": "1 - Vectors & Scalers",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "toppernotephy1.pdf"
    },
    {
      "id": "toppernotephy2",
      "name": "2 - Kinematics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "toppernotephy2.pdf"
    },
    {
      "id": "toppernotephy3",
      "name": "3 - Projectile Motion",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "toppernotephy3.pdf"
    },
    {
      "id": "toppernotephy4",
      "name": "4 - Circular Motion",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "toppernotephy4.pdf"
    },
    {
      "id": "toppernotephy5",
      "name": "5 - Laws of Motion",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "toppernotephy5.pdf"
    },
    {
      "id": "toppernotephy6",
      "name": "6 - Friction",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP06",
      "pdfPath": "toppernotephy6.pdf"
    },
    {
      "id": "toppernotephy7",
      "name": "7 - Work, Power & Energy",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP07",
      "pdfPath": "toppernotephy7.pdf"
    },
    {
      "id": "toppernotephy8",
      "name": "8 - Power",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP08",
      "pdfPath": "toppernotephy8.pdf"
    },
    {
      "id": "toppernotephy9",
      "name": "9 - Conservation of Momentum",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP09",
      "pdfPath": "toppernotephy9.pdf"
    },
    {
      "id": "toppernotephy10",
      "name": "10 - Collision",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP10",
      "pdfPath": "toppernotephy10.pdf"
    },
    {
      "id": "toppernotephy11",
      "name": "11 - Rotational Mechanics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP11",
      "pdfPath": "toppernotephy11.pdf"
    },
    {
      "id": "toppernotephy12",
      "name": "12 - Fluids",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP12",
      "pdfPath": "toppernotephy12.pdf"
    },
    {
      "id": "toppernotephy13",
      "name": "13 - Gravitation",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP13",
      "pdfPath": "toppernotephy13.pdf"
    },
    {
      "id": "toppernotephy14",
      "name": "14 - Simple Harmonic Motion",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP14",
      "pdfPath": "toppernotephy14.pdf"
    },
    {
      "id": "toppernotephy15",
      "name": "15 - Elasticity",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP15",
      "pdfPath": "toppernotephy15.pdf"
    },
    {
      "id": "toppernotephy16",
      "name": "16 - Heat & Thermodynamics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP16",
      "pdfPath": "toppernotephy16.pdf"
    },
    {
      "id": "toppernotephy17",
      "name": "17 - Calorimetry",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP17",
      "pdfPath": "toppernotephy17.pdf"
    },
    {
      "id": "toppernotephy18",
      "name": "18 - Thermodynamics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP18",
      "pdfPath": "toppernotephy18.pdf"
    },
    {
      "id": "toppernotephy19",
      "name": "19 - Waves & Sounds",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP19",
      "pdfPath": "toppernotephy19.pdf"
    },
    {
      "id": "toppernotephy20",
      "name": "20 - Current Electricity",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP20",
      "pdfPath": "toppernotephy20.pdf"
    },
    {
      "id": "toppernotephy21",
      "name": "21 - Electrostatics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP21",
      "pdfPath": "toppernotephy21.pdf"
    },
    {
      "id": "toppernotephy22",
      "name": "22 - Properties of Conductors",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP22",
      "pdfPath": "toppernotephy22.pdf"
    },
    {
      "id": "toppernotephy23",
      "name": "23 - Capacitors",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP23",
      "pdfPath": "toppernotephy23.pdf"
    },
    {
      "id": "toppernotephy24",
      "name": "24 - Dielectric",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP24",
      "pdfPath": "toppernotephy24.pdf"
    },
    {
      "id": "toppernotephy25",
      "name": "25 - Electrical Instruments",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP25",
      "pdfPath": "toppernotephy25.pdf"
    },
    {
      "id": "toppernotephy26",
      "name": "26 - Magnetics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP26",
      "pdfPath": "toppernotephy26.pdf"
    },
    {
      "id": "toppernotephy27",
      "name": "27 - Electro Magnetic Induction",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP27",
      "pdfPath": "toppernotephy27.pdf"
    },
    {
      "id": "toppernotephy28",
      "name": "28 - Wave Optics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP28",
      "pdfPath": "toppernotephy28.pdf"
    },
    {
      "id": "toppernotephy29",
      "name": "29 - Geometrical Optics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP29",
      "pdfPath": "toppernotephy29.pdf"
    },
    {
      "id": "toppernotephy30",
      "name": "30 - Modern Physics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP30",
      "pdfPath": "toppernotephy30.pdf"
    },
    {
      "id": "toppernotephy31",
      "name": "31 - Semiconductor Electronics",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP31",
      "pdfPath": "toppernotephy31.pdf"
    },
    {
      "id": "toppernotephy32",
      "name": "32 - Error Analysis",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP32",
      "pdfPath": "toppernotephy32.pdf"
    },
    {
      "id": "toppernotephy33",
      "name": "33 - Human Eye",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP33",
      "pdfPath": "toppernotephy33.pdf"
    },
    {
      "id": "toppernotephy34",
      "name": "34 - Solids & Semiconductors",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP34",
      "pdfPath": "toppernotephy34.pdf"
    },
    {
      "id": "toppernotephy35",
      "name": "35 - Logic Gate",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP35",
      "pdfPath": "toppernotephy35.pdf"
    },
    {
      "id": "toppernotephy36",
      "name": "36 - Communication System",
      "type": "toppernote",
      "subject": "physics",
      "topic": "CP36",
      "pdfPath": "toppernotephy36.pdf"
    },

    {
      "id": "toppernoteche1",
      "name": "1 - Periodic Classification",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "toppernoteche1.pdf"
    },
    {
      "id": "toppernoteche2",
      "name": "2 - Block Chemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "toppernoteche2.pdf"
    },
    {
      "id": "toppernoteche3",
      "name": "3 - Hydrogen",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "toppernoteche3.pdf"
    },
    {
      "id": "toppernoteche4",
      "name": "4 - Metallurgy",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC04",
      "pdfPath": "toppernoteche4.pdf"
    },
    {
      "id": "toppernoteche5",
      "name": "5 - Qualitative Analysis",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC05",
      "pdfPath": "toppernoteche5.pdf"
    },
    {
      "id": "toppernoteche6",
      "name": "6 - Co-ordination Chemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC06",
      "pdfPath": "toppernoteche6.pdf"
    },
    {
      "id": "toppernoteche7",
      "name": "7 - Alcohols & Phenols",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC07",
      "pdfPath": "toppernoteche7.pdf"
    },
    {
      "id": "toppernoteche8",
      "name": "8 - Aldehyde, Ketones & Carboxylic Acids",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC08",
      "pdfPath": "toppernoteche8.pdf"
    },
    {
      "id": "toppernoteche9",
      "name": "9 - Alkyl and Aryl Halides",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC09",
      "pdfPath": "toppernoteche9.pdf"
    },
    {
      "id": "toppernoteche10",
      "name": "10 - Amines",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC10",
      "pdfPath": "toppernoteche10.pdf"
    },
    {
      "id": "toppernoteche11",
      "name": "11 - Aromatic Nitro Compounds",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC11",
      "pdfPath": "toppernoteche11.pdf"
    },
    {
      "id": "toppernoteche12",
      "name": "12 - Carbohydrates",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC12",
      "pdfPath": "toppernoteche12.pdf"
    },
    {
      "id": "toppernoteche13",
      "name": "13 - General Organic Chemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC13",
      "pdfPath": "toppernoteche13.pdf"
    },
    {
      "id": "toppernoteche14",
      "name": "14 - Hydrocarbons",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC14",
      "pdfPath": "toppernoteche14.pdf"
    },
    {
      "id": "toppernoteche15",
      "name": "15 - Practical Organic Chemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC15",
      "pdfPath": "toppernoteche15.pdf"
    },
    {
      "id": "toppernoteche16",
      "name": "16 - Reaction Mechanism",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC16",
      "pdfPath": "toppernoteche16.pdf"
    },
    {
      "id": "toppernoteche17",
      "name": "17 - Atomic Structure",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC17",
      "pdfPath": "toppernoteche17.pdf"
    },
    {
      "id": "toppernoteche18",
      "name": "18 - Chemical Bonding",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC18",
      "pdfPath": "toppernoteche18.pdf"
    },
    {
      "id": "toppernoteche19",
      "name": "19 - Ionic Equilibrium",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC19",
      "pdfPath": "toppernoteche19.pdf"
    },
    {
      "id": "toppernoteche20",
      "name": "20 - Chemical Equilibrium",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC20",
      "pdfPath": "toppernoteche20.pdf"
    },
    {
      "id": "toppernoteche21",
      "name": "21 - Gaseous State",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC21",
      "pdfPath": "toppernoteche21.pdf"
    },
    {
      "id": "toppernoteche22",
      "name": "22 - Chemical Thermodynamics and Thermochemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC22",
      "pdfPath": "toppernoteche22.pdf"
    },
    {
      "id": "toppernoteche23",
      "name": "23 - Solutions and Colligative Properties",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC23",
      "pdfPath": "toppernoteche23.pdf"
    },
    {
      "id": "toppernoteche24",
      "name": "24 - Solid State",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC24",
      "pdfPath": "toppernoteche24.pdf"
    },
    {
      "id": "toppernoteche25",
      "name": "25 - Surface Chemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC25",
      "pdfPath": "toppernoteche25.pdf"
    },
    {
      "id": "toppernoteche26",
      "name": "26 - Chemical Kinetics and Radioactivity",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC26",
      "pdfPath": "toppernoteche26.pdf"
    },
    {
      "id": "toppernoteche27",
      "name": "27 - ElectroChemistry",
      "type": "toppernote",
      "subject": "chemistry",
      "topic": "CC27",
      "pdfPath": "toppernoteche27.pdf"
    }



  ]

export default PdfFiles;